import expenseAr from './ar.json'

const messages = {
  ar: {
    ...expenseAr,
  },
}

export default messages
